import { useLoginStore } from '@/stores/login';
import { useCartStore } from '@/stores/cart';
import { useDoorStore } from '@/stores/door';
import { usePublicStore } from '@/stores/public';
import { TABLE_VIEW_TYPE } from '@/constants/table.js';

import { tryFallbackPaths } from '@/utils/read_config';
import { jumpRePages } from '@/utils/public';
import { useLoading } from '@/hooks/useLoading';
import { ref } from 'vue';
const { showLoading, hideLoading } = useLoading();
import { logInfo } from '@/uni_modules/gp-logcat';
import moment from 'moment-timezone';

let timeOffset = null;
const requestCache = new Map();
const MAX_CACHE_SIZE = 20;
let CACHE_WINDOW = 300; // 缓存窗口期300ms
// #ifdef App-Plus
CACHE_WINDOW = 1500; // App端缓存窗口期1s
// #endif
// 基础url
export let baseUrl = '';
// 设置基础url
export function setBaseUrl(url) {
    baseUrl = url;
    uni.setStorageSync('baseUrl', url);
}
// 环境枚举
export const AppEnvEnum = ref({
    0: 'https://saas-billiard.wfydiaozhatian.com', // 开发环境
    1: 'https://api.dwjtq.com', // 正式环境
    2: 'https://api-dwjtq.dianwj.com', //预发布
    3: 'http://192.168.3.133:9501', // 刘弢
    4: 'http://192.168.3.72:9501', // c
    5: 'http://192.168.3.114:9501', // 申胜利
    6: 'http://192.168.3.69:9501', // 韩潮江
    7: 'http://192.168.3.183:9501', // 何超
    8: 'http://192.168.3.218:9501', // 石磊
    9: 'http://192.168.3.50:9501', // 赵志杨
    10: 'http://192.168.3.52:9501', // 刘凯
    11: 'http://192.168.3.144:9501', // 柯豪
    12: 'http://192.168.3.32:9501', // 王龙鹤
    13: 'http://192.168.3.110:9501', // 董杰,
    14: 'http://localhost:9501' // 本地
});
const env = import.meta.env.VITE_NODE_ENV || 'production';
if (env === 'development') {
    baseUrl = uni.getStorageSync('baseUrl') || AppEnvEnum.value[0];
} else {
    baseUrl = AppEnvEnum.value[0];
}
const getUrl = async () => {
    if (env != 'development') {
        baseUrl = (await tryFallbackPaths()) || AppEnvEnum.value[1];
    }
};

let init = true;

export const request = async (url, method = 'GET', data = {}, header = {}, loading = false, msg = '') => {
    if (init) {
        await getUrl();
        await usePublicStore().getDeviceCode();
        init = false;
    }
    // #ifdef H5
    if (usePublicStore().isOfflineH5) {
        uni.$emit('showToast', { title: '网络已断开', type: 'none' });
    }
    // #endif
    if (loading) {
        showLoading(msg || '加载中...');
    }

    // 生成请求唯一标识
    const cacheKey = `${method}:${url}:${JSON.stringify(data)}`;
    const now = Date.now();
    if (requestCache.has(cacheKey)) {
        const cacheItem = requestCache.get(cacheKey);
        // 调用时才比对时间，不需要提前用setTimeout清理
        if (now - cacheItem.requestTime < CACHE_WINDOW) {
            console.log('命中');
            if (loading) hideLoading();
            return cacheItem.promise;
        }
        // 2. 超过300ms → 删除过期缓存，后续重新发起请求
        requestCache.delete(cacheKey);
    }

    // 3. 【新增】检查缓存容量，如果达到上限，删除最旧的缓存项
    if (requestCache.size >= MAX_CACHE_SIZE) {
        // Map 的 keys() 返回一个迭代器，按插入顺序排列
        const oldestKey = requestCache.keys().next().value;
        if (oldestKey) {
            requestCache.delete(oldestKey);
            console.log(`缓存已满(${MAX_CACHE_SIZE})，移除最旧缓存:`, oldestKey);
        }
    }
    const requestPromise = new Promise((resolve, reject) => {
        // 购物车
        const cart = useCartStore();
        const loginstore = useLoginStore();
        const publicStore = usePublicStore();
        const savedToken = uni.getStorageSync('loginToken');
        const savedShopId = uni.getStorageSync('shopId');
        header['Authorization'] = loginstore.loginToken || savedToken;
        header['Channel'] = 'cashier';
        // header['Pos-device-code'] = uni.getSystemInfoSync().deviceId || '';
        let deviceCode = publicStore.systemInfo.deviceCode || '';
        // #ifdef H5
        const type = sessionStorage.getItem('type');
        if (type === 'back') {
            const shopConfig = sessionStorage.getItem('deviceCode_back');
            deviceCode = shopConfig || deviceCode;
        }
        // #endif
        header['Pos-device-code'] = deviceCode;
        const query = {
            shop_id: loginstore.currentShopId || savedShopId || 0,
            ...data
        };
        let timeoutStep = 30 * 1000;
        if (header?.timeout) {
            timeoutStep = header?.timeout;
            delete header?.timeout;
        }
        // console.log('请求参数------', query);

        // 发起请求
        uni.request({
            url: baseUrl + url,
            method: method,
            data: query,
            timeout: timeoutStep,
            header: { ...header },

            success: async (res) => {
                const serverDateStr = res.header['server-time'];
                if (serverDateStr && !timeOffset) {
                    const localTime = Date.now();
                    timeOffset = localTime - serverDateStr * 1000;
                    console.log('时间已校准，偏移量(ms):', timeOffset);
                    console.log('本地时间:', getServerMoment().format('YYYY-MM-DD HH:mm:ss'));
                    // console.log('服务器时间:', new Date(serverDateStr).toISOString());
                }

                // console.log('响应参数------', res);
                if (loading) hideLoading();
                const temp_data = res.data;
                const { code, message } = res.data;
                if (code == 401) {
                    uni.$emit('showToast', { title: '登录过期，请重新登录', type: 'none' });
                    loginstore.exitLogin();
                    return jumpRePages('/pages/login');
                }
                // 约定1002，零售收音机被删，需要重新登录
                if (code == 1002) {
                    loginstore.exitLogin();
                    return jumpRePages('/pages/login');
                }
                // 432 拦截：密码校验 + 重新请求原接口
                if (code == 432) {
                    // 保存当前请求的所有参数
                    const originalRequest = {
                        url: url,
                        method: method,
                        data: data,
                        header: header
                    };

                    const doVerify = async (errMsg = '') => {
                        try {
                            // 打开密码验证弹窗
                            const formData = await new Promise((resolve, reject) => {
                                uni.$emit('openVerifyPasswordPopup', {
                                    onSuccess: resolve,
                                    onCancel: reject,
                                    params: {
                                        type: temp_data?.data?.type,
                                        status: temp_data?.data?.status,
                                        errorMsg: errMsg,
                                        approval_id: temp_data?.data?.approval_id
                                    }
                                });
                            });

                            // 密码认证
                            if (formData.authType === '1') {
                                uni.showLoading({ title: '验证中...' });
                                // 1. 先校验密码
                                const verifyRes = await request('/_hotel/approval/verifyPwd', 'POST', formData);
                                uni.hideLoading();
                                if (verifyRes.code === 200) {
                                    uni.$emit('closeVerifyPasswordPopup');
                                    // 2. 校验成功 → 重新请求之前被拦截的接口
                                    let url = verifyRes?.data?.payload?.url || originalRequest.url;
                                    let method = verifyRes?.data?.payload?.method || originalRequest.method;
                                    let data = { ...verifyRes?.data?.payload?.body, approval_id: verifyRes?.data?.id };
                                    let header = { ...originalRequest.header, 'approval-id': verifyRes?.data?.id };
                                    const retryRes = await request(url, method, data, header, true);
                                    if (retryRes?.code == 200) {
                                        // 3. 关闭密码弹窗
                                        // uni.$emit('closeVerifyPasswordPopup');
                                        // 4. 把最新数据返回给业务调用方
                                        resolve(retryRes);
                                    }
                                    return;
                                } else {
                                    // 验证失败，重新弹窗
                                    doVerify(verifyRes.message || '验证失败');
                                }
                                return;
                            }

                            // 权限申请
                            // if (formData.authType === '2') {
                            //     uni.showLoading({ title: '提交申请...' });
                            //     const applyRes = await request('/api/applyPermission', 'POST', formData);
                            //     uni.hideLoading();

                            //     if (!applyRes.data?.requestId) {
                            //         doVerify('申请提交失败');
                            //         return;
                            //     }
                            //     if (typeof verifyPopupRef !== 'undefined' && verifyPopupRef.value) {
                            //         verifyPopupRef.value.startPolling(applyRes.data.requestId, (success) => {
                            //             if (success) {
                            //                 uni.$emit('closeVerifyPasswordPopup');
                            //                 resolve(temp_data);
                            //             } else {
                            //                 doVerify('审核失败');
                            //             }
                            //         });
                            //     } else {
                            //         uni.$emit('showToast', { title: '轮询组件未找到', type: 'none' });
                            //         reject(temp_data);
                            //     }
                            // }
                        } catch (e) {
                            console.error('验证异常：', e);
                            // try {const cancel =
                            await request('/_hotel/approval/cancelApprove', 'POST', { ...e });
                            // } catch {
                            //     console.log(cancel)
                            // }
                            // 关闭弹窗
                            uni.$emit('closeVerifyPasswordPopup');
                            reject(temp_data);
                            uni.$emit('showToast', { title: '取消验证', type: 'none' });
                        } finally {
                            uni.hideLoading();
                        }
                    };

                    doVerify('');
                    return;
                }
                if (code == 1000) {
                    cart.clearAll('normal');
                    uni.$emit('showToast', { title: message, type: 'none' });
                    useDoorStore().setTableType(TABLE_VIEW_TYPE.INDEX);
                    reject(res.data);
                    return;
                }
                //  1001 ,为在线支付中的，特殊处理支付中
                if (code == 200 || code == 1001) {
                    resolve(res.data);
                    return;
                }
                if (data?.goods) {
                    resolve(res.data);
                    return;
                }
                uni.$emit('showToast', {
                    title: message || '请求失败',
                    type: 'error',
                    duration: 3000
                });
                setTimeout(() => {
                    uni.hideToast();
                    resolve(res.data);
                }, 1500);
            },

            fail: (err) => {
                requestCache.delete(cacheKey);
                if (loading) hideLoading();
                logInfo('请求失败', { url });
                const result = { code: 500, msg: '获取数据失败' };
                reject(result);
            },

            complete: () => {
                uni.hideLoading();
            }
        });
    });
    // 将首次请求信息存入缓存
    requestCache.set(cacheKey, {
        requestTime: now,
        promise: requestPromise
    });
    return requestPromise;
};
export const getServerMoment = () => {
    const correctedTime = Date.now() - (timeOffset || 0);
    return moment(correctedTime).tz('Asia/Shanghai');
};
export const uploadFun = (tempFilePath, header = {}, business = 'chat') => {
    return new Promise((resolve, reject) => {
        console.log('上传文件');
        const loginstore = useLoginStore();
        const publicStore = usePublicStore();
        header['Authorization'] = loginstore.loginToken;
        header['Channel'] = 'cashier';
        header['Pos-device-code'] = publicStore.systemInfo.deviceCode || '';
        header['Access-Hotel'] = publicStore.config?.hid || '';
        console.log(`${baseUrl}/upload`);
        uni.uploadFile({
            url: `${baseUrl}/upload`,
            filePath: tempFilePath,
            name: 'file',
            // 相同逻辑用最新：business 参数 + deviceid
            formData: {
                business,
                file: tempFilePath,
                posdevicecode: publicStore.systemInfo.deviceCode || ''
            },
            header: { ...header },
            success: (uploadRes) => {
                console.log('uploadRes----', uploadRes);
                if (uploadRes.data) {
                    const { data } = JSON.parse(uploadRes.data);
                    if (uploadRes.statusCode === 200) resolve(data);
                } else {
                    reject(false);
                }
            },
            fail: (err) => {
                console.error('上传失败:', err);
                uni.showToast({
                    title: '请检查网络',
                    icon: 'none'
                });
                reject(err);
            }
        });
    });
};

export const assets_url = 'https://oss-hongzhong.kstxyl.com/saas_billiard/app_static/';
